import React, { useState, useEffect } from "react";
import PortfolioCard from "./PortfolioCard";
import PortfolioHeader from "../PageHeader/PageHeader";
import PortfolioFooter from "../PageHeader/PageFooter";
import CircularLoader from "./../BackDrop/CircularLoader";
import db from "../firebase";
import "./Portfolio.css";

const Portfolio = () => {
  const [portfolios, setPortfolios] = useState([]);

  useEffect(() => {
    db.collection("portfolio")
      .orderBy("date", "desc")
      .onSnapshot((snapshot) =>
        setPortfolios(snapshot.docs.map((doc) => doc.data()))
      );
  }, []);

  return (
    <div className="portfolio">
      <PortfolioHeader title="Portfolio" />
      <div className="portfolio__body">
        {portfolios === undefined || portfolios.length === 0 ? (
          <CircularLoader />
        ) : (
          portfolios.map((portfolio) => (
            <PortfolioCard
              key={portfolio.id}
              title={portfolio.title}
              subtitle={portfolio.subtitle}
              date={portfolio.date}
              detailsurl={portfolio.detailsurl}
              githuburl={portfolio.githuburl}
              siteurl={portfolio.siteurl}
              initial={portfolio.initial}
              desc={portfolio.desc}
              url={portfolio.src}
              technologies={portfolio.technologies}
            />
          ))
        )}
      </div>
      <PortfolioFooter />
    </div>
  );
};

export default Portfolio;
